import { ELASTIC_SEARCH_MAXIMUM_PAGE } from 'constants/pagination'
import {
  extractFilterFromQuery,
  extractNoneFilterFromQuery,
  normalizeFilterFromQuery,
} from 'helpers/filter'
import { redirect } from 'helpers/navigation'
import { FetchProps } from 'helpers/redial'
import { extractSortIdFromQuery } from 'helpers/sort'
import shallowEqual from 'shallowequal'
import ImageViewStore from 'store/features/imageView'

export default function handleQueryParamsForStreamPage(
  { pathname, query, store }: FetchProps,
  availableFilterSlugs: Set<string>,
) {
  const queryFilter = extractFilterFromQuery(query, availableFilterSlugs, [
    'term',
  ])
  const queryNoneFilter = extractNoneFilterFromQuery(
    query,
    availableFilterSlugs,
  )
  const selectedFilters = normalizeFilterFromQuery(
    queryFilter,
    availableFilterSlugs,
  )

  if (!shallowEqual(queryFilter, selectedFilters)) {
    throw redirect(
      pathname,
      { ...queryNoneFilter, ...selectedFilters },
      {
        replaceState: true,
      },
    )
  }

  const currentPage = query.page ? parseInt(query.page, 10) : 1

  if (currentPage > ELASTIC_SEARCH_MAXIMUM_PAGE || currentPage < 0) {
    throw redirect(
      pathname,
      { ...queryNoneFilter, ...selectedFilters, page: undefined },
      {
        replaceState: true,
      },
    )
  }

  if (ImageViewStore.isImageType(query.preferredProductImage)) {
    store.imageView.updateUserImageType(query.preferredProductImage)
  }

  const sortId = extractSortIdFromQuery(query)
  const pageIsFiltered = Object.keys(selectedFilters).length > 0

  return {
    sortId,
    pageIsFiltered,
    queryNoneFilter,
    selectedFilters,
    currentPage,
    queryFilter,
  }
}
